export default [
   {
    name: 'Rules',
    path: '/risk-engine/rules',
    component: () => import('./pages/Rules'),
    meta: {
     ability: [
       {
         resource: 'rules',
         actions: ['read'],
       },
     ],
    },
  },
]
